import { UploadedUppyFile } from '@uppy/core';

import { AppNS } from 'app';
export const parseUploadedFilesData = (
  data: Array<UploadedUppyFile<{}, {}>>
): Array<AppNS.UploadedFileData> => {
  return data.map((item: UploadedUppyFile<{}, {}>) => {
    return {
      name: item.name,
      type: item.type,
      uploadUrl: item.uploadURL,
    } as AppNS.UploadedFileData;
  });
};
